import { Flex, Space } from "antd";
import { Trans, useTranslation } from "react-i18next";
import { AppButton, AppLink, AppParagraph, AppTitle } from "@/shared/Components";
import { AlertCircleRed } from "@/shared/icons";
import { useAuth } from "@/services/auth";
import { installationConfig } from "@/shared/constants/installation-config";
import { SupportLinks } from "@/common/SupportLinks";
import styles from "./styles.module.scss";

type Props = {
  type?:
    | "blocked"
    | "registration-attempts"
    | "on-prem"
    | "on-prem-active"
    | "on-saas-active"
    | "unknown";
};

export const Blocked = ({ type = "registration-attempts" }: Props) => {
  const { t } = useTranslation();

  const { logoutHandler } = useAuth();

  const titleMap = {
    blocked: t("common.blocked"),
    "registration-attempts": t("registrationPage.attemptExceeded.title"),
    "on-prem": t("registrationPage.onPrem.title", {
      value: installationConfig.name,
    }),
    "on-prem-active": t("registrationPage.successRegistrationTitle", {
      value: installationConfig.name,
    }),
    "on-saas-active": t("registrationPage.successRegistrationTitle", {
      value: installationConfig.name,
    }),
    unknown: t("registrationPage.blockedStep.unknown"),
  };

  const buttonText = {
    blocked: t("common.logOut"),
    "registration-attempts": t("common.logOut"),
    "on-prem": t("registrationPage.blockedStep.goToLogin"),
    "on-prem-active": t("registrationPage.blockedStep.goToLogin"),
    "on-saas-active": t("registrationPage.blockedStep.goToLogin"),
    unknown: t("common.logOut"),
  };

  return (
    <Flex gap={16}>
      {["blocked", "registration-attempts", "unknown"].includes(type) && <AlertCircleRed />}
      <Flex vertical style={{ width: "50%" }} gap={16}>
        <AppTitle
          level={["on-prem-active", "on-saas-active"].includes(type) ? 1 : 4}
          className={styles.title}
        >
          {titleMap[type]}
        </AppTitle>
        {["on-prem-active", "on-saas-active"].includes(type) && (
          <AppParagraph size="sm" className={styles.subtitle}>
            {type === "on-prem-active" ? (
              t("registrationPage.onPrem.active")
            ) : (
              <Trans
                i18nKey="registrationPage.onSaas.active"
                components={{
                  link: (
                    <AppLink
                      href={installationConfig.saasRedirect}
                      target="_blank"
                      className={styles.subtitle}
                    >
                      {installationConfig.saasRedirect}
                    </AppLink>
                  ),
                }}
              />
            )}
          </AppParagraph>
        )}
        <Space direction="vertical">
          <SupportLinks iconStroke="#FAAD14" className={styles.support} />
          {!["on-prem-active", "on-saas-active"].includes(type) && (
            <AppButton onClick={logoutHandler} className={styles["go-to-login-button"]}>
              {buttonText[type]}
            </AppButton>
          )}
        </Space>
      </Flex>
    </Flex>
  );
};
